<template>
  <div class="reset-password">
    <div class="mdl-card mdl-shadow--2dp" v-if="state=='loading'">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ i18n().loading.title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand loading">
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
        <p>{{ i18n().loading.text }}</p>
      </div>
    </div>

    <div class="mdl-card mdl-shadow--2dp" v-if="state=='used' || state=='expired' || state=='done' || state=='notFound'">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ i18n()[state].title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand loading">
        <p>{{ i18n()[state].text }}</p>
      </div>
      <div v-if="state =='done'" class="mdl-card__actions mdl-card--border" :class="{blurred: state=='loging'}">
        <button @click="login" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n()[state].loginButton }}
        </button>
      </div>
    </div>

    <div class="mdl-card mdl-shadow--2dp" v-if="state=='ready' || state=='working'">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="error" v-if="error">
          <span v-if="error">{{ i18n().errors[error] || error }}</span>
        </div>

        <form v-on:submit="change" v-bind:class="{ blurred: state == 'working' }">

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword1" v-model="newPassword1"
                   v-bind:required="required" ref="newPassword1">
            <label class="mdl-textfield__label" for="newPassword1">{{ i18n().newPassword }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="newPassword2" v-model="newPassword2"
                   v-bind:required="required" ref="newPassword2">
            <label class="mdl-textfield__label" for="newPassword2">{{ i18n().retypePassword }}</label>
            <span v-if="notMatch" class="mdl-textfield__error">{{ i18n().notMatch }}</span>
          </div>

          <button class="mdl-button mdl-js-button mdl-button--raised" type="submit">
            {{ i18n().submit }}
          </button>

        </form>

        <div class="working" v-if="state == 'working'">
          <div class="mdl-spinner mdl-js-spinner is-active"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import api from "api"
  import i18n from "i18n"

  export default {
    name: 'reset-password',
    data () {
      return {
        notMatch: false,
        error: null,
        state: 'loading',
        required: false,
        newPassword1: '',
        newPassword2: '',
        observable: null,
        keyState: false
      }
    },
    computed: {
      key() {
        return this.$route.params.key
      }
    },
    watch: {
      key() {
        this.readKey()
      },
      keyState(v) {
        if(this.state!='done' && v && v.expired) {
          this.state='expired'
          return
        }
        if(this.state == 'loading') {
          if(!v) {
            this.state = 'notFound'
            return;
          }
          if(v.used) {
            this.state = 'used'
          } else if(v.expired) {
            this.state = 'expired'
          } else {
            this.state = 'ready'
          }
        }
      }
    },
    methods: {
      i18n() { return i18n().emailPassword.resetPassword },

      readKey() {
        if(this.observable) this.observable.unbindProperty(this, "keyState")
        this.state = 'loading'
        this.observable = api.observable(['emailPassword', 'emailKey', this.key])
        //this.observable.value = undefined
        this.observable.bindProperty(this, "keyState")
      },

      change(e) {
        e.preventDefault()

        if(this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
          this.required = true
          if(this.newPassword2.trim()=='') {
            this.$refs.newPassword2.parentElement.setAttribute('class',
              this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.newPassword2.focus()
          }
          if(this.newPassword1.trim()=='') {
            this.$refs.newPassword1.parentElement.setAttribute('class',
              this.$refs.newPassword1.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.newPassword1.focus()
          }
          return
        }

        this.notMatch = (this.newPassword1 != this.newPassword2)
        if(this.notMatch) {
          this.$refs.newPassword2.parentElement.setAttribute('class',
            this.$refs.newPassword2.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.newPassword2.focus()
          return;
        }

        this.state = "working"
        logger.addPassword(this.newPassword1)
        api.request(["emailPassword", "finishPasswordReset"], this.key, this.newPassword1).then(result => {
          logger.removePassword(this.newPassword1)
          this.state = "done"
        }).catch(error => {
          this.error = error
          this.state = "ready"
        })
      },

      login() {
        this.state = "loging"
        logger.addPassword(this.newPassword1)
        api.request(["emailPassword", "login"], this.keyState.email, this.newPassword1).then(result => {
          logger.removePassword(this.newPassword1)
          this.state = "done"
        }).catch(error => {
          this.error = error
          this.state = "done"
          this.$router.replace({name: 'index'})
        })
      }
    },
    created() {
      this.readKey()
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .reset-password {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../../../static/images/voleadstools2.png);
    background-position: center;
    background-size: 280%;
  }

  .mdl-card {
    width: 320px;
    margin: auto;
  }
  .mdl-card__title {
    height: 110px;
    color: #fff;
    background: url(../../../static/images/voleadstools2_mid.png) 215px 5px no-repeat #241d7f;
    background-size: 100px;
  }

  button {
    background: #1d0585;
    color: white;
    font-weight: 300;
    float: right;
  }

  button:hover {
    background: #2906bf;
    color: white;
    font-weight: 300;
  }

  .mdl-card__supporting-text {
    position: relative;
  }

  form.blurred {
    filter: blur(2px);
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .error {
    height: 3em;
    font-size: 1.23em;
    color: #d00000;
  }

  .loading {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?68c751ce